import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { InputItem } from "../../../components/forms/FormItems";
import {
  BranchSelect,
  RolesSelect,
  EmployeesSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import { createInvite } from "../registrationSlice";
import { parsePhoneNumber } from "libphonenumber-js";
import { useSelector } from "react-redux";
import AddEntityForm from "../../../components/templates/AddEntityForm";

const AddUserForm = (props) => {
  const { hide, visible, addText } = props;
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.pendingActions["registration/createInvitation"]
  );
  const [allBranches, setAllBranches] = useState(false);

  const professionalFilter = {
    $and: [
      {
        $or: [
          { professional_role_id: 1 },
          { professional_role_id: 2 },
          { professional_role_id: 3 },
          { professional_role_id: 4 },
          { controller: true },
        ],
      },
      { $or: [{ status: 1 }, { status: 3 }] },
    ],
  };
  const onFinish = async (values) => {
    const phoneNumber = parsePhoneNumber(values.phone_number);
    values["phone_number"] = phoneNumber.number;
    const action = await dispatch(createInvite(values));
    if (!action.error) {
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onChange = (e) => {
    setAllBranches(e.target.checked);
  };

  const items = [
    {
      name: "name",
      required: true,
      comp: <InputItem required={true} name="name" category="user" />,
    },
    {
      name: "user_name",
      required: true,
      comp: (
        <InputItem
          name="user_name"
          required={true}
          category="user"
          email={true}
        />
      ),
    },

    {
      name: "role_id",
      required: true,
      comp: <RolesSelect name="role_id" required={true} category="user" />,
    },
    {
      name: "user_name",
      required: true,
      comp: (
        <CheckBoxItem
          showLabel={true}
          name="all_branches"
          category="user"
          onChange={onChange}
        />
      ),
    },
    {
      name: "branches",
      required: !allBranches,
      comp: !allBranches ? (
        <BranchSelect
          name="branches"
          category="user"
          required={true}
          clear={!visible}
          mode="multiple"
        />
      ) : null,
    },
    {
      name: "associated_employee_id",
      required: false,
      comp: (
        <EmployeesSelect
          name="associated_employee_id"
          category="user"
          extraParams={{
            filter: professionalFilter,
          }}
          proffesional={true}
        />
      ),
    },
    {
      name: "has_desktop_access",
      required: false,
      comp: (
        <CheckBoxItem
          showLabel={true}
          name="has_desktop_access"
          category="user"
        />
      ),
    },

    {
      name: "has_mobile_access",
      required: false,
      comp: (
        <CheckBoxItem
          showLabel={true}
          name="has_mobile_access"
          category="user"
        />
      ),
    },
    {
      name: "has_minimum_mobile_access",
      required: false,
      comp: (
        <CheckBoxItem
          showLabel={true}
          name="has_minimum_mobile_access"
          category="user"
        />
      ),
    },
    {
      name: "phone_number",
      required: true,
      comp: (
        <PhoneNumberItem
          required={true}
          name="phone_number"
          category="user"
          isMobile={true}
        />
      ),
    },
  ];

  return (
    <AddEntityForm
      formLayout={{
        labelCol: { span: 10 },
        wrapperCol: { span: 14 },
      }}
      padding={"0 100px"}
      resource="users"
      action="editor"
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onDecline}
      saveLoading={loading}
      addText={addText}
      mode={"withInitial"}
      activeEntity={{ has_desktop_access: true }}
    />
  );
};

AddUserForm.propTypes = {
  hide: PropTypes.func,
  visible: PropTypes.bool,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default AddUserForm;
